import { IDocFieldHandler } from "./IDocFieldHandler";
import { IDHFSectionOptions } from "../../PluginManagerDocuments";
import { IReference } from "../../../../globals";
import { IItemListOptions } from "./ItemListDocFieldHandler";
import { ItemSelectionAbstractDocFieldHandler } from "./ItemSelectionAbstractDocFieldHandler";

export interface ILinkListOptions extends IDHFSectionOptions {
    showExternal: number;
    includeInToc: boolean;
    search?: string;
}

export class LinkListDocFieldHandler extends ItemSelectionAbstractDocFieldHandler implements IDocFieldHandler {
    getDefaultConfig(): ILinkListOptions {
        return { showExternal: 1, includeInToc: false };
    }

    getXmlValue(): string {
        let reflist = <IReference[]>this.getItems();

        for (let idx = 0; idx < reflist.length; idx++) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            (<ILinkListOptions>(<any>reflist[idx]))["showExternal"] = this.dhfFieldConfig.showExternal;
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            (<IItemListOptions>(<any>reflist[idx]))["includeInToc"] = this.dhfFieldConfig.includeInToc;
        }

        return JSON.stringify(reflist);
    }
}
